import "../styles/component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function MedicalGasteroenterology() {
  return (
        <>
            <section className="general-surgery hide-on-mobile">
                <img
                    src={require("../assets/img/services/big-14.png")}
                    alt="General Surgery"
                    className="top-band-img"
                />
            </section>
            <section className="general-surgery-content">
                <div className="1stblock">
                    <span className="title">What is Medical Gastroenterology?</span>
                    <p>
                        This specialty focuses on non-surgical treatment of digestive system disorders.
                    </p>
                </div>
                <div className="general-surgery-row">
                    <div className="general-surgery-col general-surgery-col-1">
                        <span className="subtitle">Services Include:</span>
                        <ul className="general-surgery-list">
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Evaluation of gastrointestinal conditions
                            </li>
                            <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Medical management and follow-up care
                            </li>
                            {/* <li>
                                <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                Post-trauma and post-surgical reconstruction
                            </li> */}
                        </ul>
                    </div>
                    <div className="general-surgery-col general-surgery-col-2">
                        <span className="subtitle">Why This Service Matters</span>
                        <p>Digestive health plays a key role in overall well-being and requires timely medical attention.</p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MedicalGasteroenterology;
